/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Official_Required_To_Add_PlayerInputs */



/**
* | output |
* | --- |
* | "Only a VEKN official (IC, NC or Prince, from any country) can add a player without a VEKN ID, signed in on their own account. Ask one to sign in here." |
*
* @param {Official_Required_To_Add_PlayerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const official_required_to_add_player = /** @type {((inputs?: Official_Required_To_Add_PlayerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Official_Required_To_Add_PlayerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Seul un officiel VEKN (IC, NC ou Prince, de n'importe quel pays) peut ajouter un joueur sans ID VEKN, connecté avec son propre compte. Demandez à l'un d'eux de se connecter ici.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solo un oficial de la VEKN (IC, NC o Prince, de cualquier país) puede añadir un jugador sin ID VEKN, con su propia cuenta. Pida a uno que inicie sesión aquí.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Só um oficial da VEKN (IC, NC ou Prince, de qualquer país) pode adicionar um jogador sem ID VEKN, pela própria conta. Peça a um deles para entrar aqui.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Solo un ufficiale VEKN (IC, NC o Prince, di qualsiasi paese) può aggiungere un giocatore senza ID VEKN, dal proprio account. Chiedi a uno di loro di accedere qui.")
	return /** @type {LocalizedString} */ ("Only a VEKN official (IC, NC or Prince, from any country) can add a player without a VEKN ID, signed in on their own account. Ask one to sign in here.")
});